import ReactDOM from 'react-dom/client';
import App from './App';

// NOTE: React.StrictMode hata diya hai. Development me StrictMode har effect ko 2 baar chalata hai,
// isi wajah se Network tab me config / profile / active do-do baar dikh rahe the.
// (Upar se api/dedupe.js bhi same in-flight GET ko ek hi call me jod deta hai.)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
